import { SubTrigger } from "@radix-ui/react-dropdown-menu";

export const DropdownMenuSubTrigger = SubTrigger;
